import { render, staticRenderFns } from "./option-modal.vue?vue&type=template&id=aaee1a2a&scoped=true&"
import script from "./option-modal.vue?vue&type=script&lang=js&"
export * from "./option-modal.vue?vue&type=script&lang=js&"
import style0 from "./option-modal.vue?vue&type=style&index=0&id=aaee1a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaee1a2a",
  null
  
)

export default component.exports